import "lodash"

function isBlank(value) {
  return _.isEmpty(value) && !_.isNumber(value) || _.isNaN(value);
}

_.mixin({ 'isBlank': isBlank });
